<p class="loan-select-header" *ngIf="portFolioInd == '4'">
  Select the loans that need to be transferred :
</p>


<div class="col col-md-4 offset-md-3" *ngIf="portFolioInd == '4'">
<fm-multiselect
  ariaLabelledBy="defaultMultiselect"
  [maxSelectedLabels]="1"
  [options]="loanDetailsDisplay"
  [(ngModel)]="selectedLoans"
  [filter]="true"
  [virtualScroll]="true"
  ></fm-multiselect>

</div>

<div class="col col-md-4 offset-md-3" *ngIf="portFolioInd=='1'">
  Are you sure that you want to transfer ALL loans
</div>

<div class="col col-md-4 offset-md-3" *ngIf="portFolioInd=='2'">
  Are you sure that you want to transfer ALL HECM loans
</div>


<div class="col col-md-4 offset-md-3" *ngIf="portFolioInd=='3'">
  Are you sure that you want to transfer ALL HKM loans
</div>
<div class="btnAlign">
  <button fmButton type="button" [small]="true" label="Clear" (click)="clearBtn()"
          class="dispbuttonMargin"></button>

  <!--  (click)="clearBtn()" -->

  <button fmButton type="button" (click)="loanSubmit()" [small]="true" [primary]="true" label="Submit"
          class="dispbuttonMargin"></button>
  <!--  (click)="serviceTransferLoanSelectSubmit()" -->
</div>
